<template>
  <div 
    class="d-flex flex-column align-start" 
    :title="timestamp ? formatTimeAndDate(timestamp) : ''"
  >
    <span class="caption" style="white-space: nowrap">{{ formattedDate }}</span>
    <span v-if="timestamp" style="white-space: nowrap">
      {{ formattedTime }}
    </span>
  </div>
</template>

<script>
import { formatTimeAndDate, formatShortDate } from "@/utils";
import { useSettingsStore } from "@/store/index";

export default {
  name: "DateTimeLayout",
  props: {
    timestamp: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    formattedDate() {
      if (!this.timestamp) return "-";
      return formatShortDate(this.timestamp);
    },
    formattedTime() {
      if (!this.timestamp) return "";
      const epoch = this.timestamp;
      const toMs = v => {
        const n = Number(v);
        if (!isFinite(n)) return Date.now();
        return n > 1e12 ? n : Math.round(n * 1000);
      };
      const date = new Date(toMs(epoch));
      const settingsStore = useSettingsStore();
      const timeZone = settingsStore.timezone === 'BRT' ? 'America/Sao_Paulo' : 'UTC';
      const timezoneLabel = settingsStore.timezone;
      
      const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone
      };
      
      const formattedTime = new Intl.DateTimeFormat('pt-BR', timeOptions).format(date);
      return `${formattedTime} ${timezoneLabel}`;
    },
  },
  methods: {
    formatTimeAndDate(epoch) {
      return formatTimeAndDate(epoch);
    },
  },
};
</script>
